// src/app/Auth/utils/roleRedirect.js

import { ROUTES } from "../../shared/constants/routes";

export function getDashboardByRole(role) {
  switch (role) {
    case "ADMIN":
      return ROUTES.ADMIN_DASHBOARD;
    case "DOCTOR":
      return ROUTES.DOCTOR_DASHBOARD;
    case "PATIENT":
      return ROUTES.PATIENT_DASHBOARD;
    default:
      return ROUTES.AUTH_LOGIN;
  }
}